/**
 * Resolve a run-report case row to its index in the linked test plan.
 *
 * @param {Array<Object>} planCases
 * @param {Object} reportCase
 * @returns {number} Zero-based plan case index, or -1 when not found.
 */
export const resolvePlanCaseIndex = (planCases, reportCase) => {
  const cases = Array.isArray(planCases) ? planCases : [];
  if (reportCase?.name) {
    const byName = cases.findIndex((c) => c?.name === reportCase.name);
    if (byName >= 0) return byName;
  }
  if (
    Number.isInteger(reportCase?.case_index) &&
    reportCase.case_index >= 0 &&
    reportCase.case_index < cases.length
  ) {
    return reportCase.case_index;
  }
  return -1;
};
